<template>

    <div>
        <!--nav Header-->
        <v-toolbar fixed dense class="semi-transparent-7-bg" style="height: 50px;" :clipped-right=true app>

            <div class="toolbar-container">

                <v-btn icon v-if="this.$route.name !== 'home'" @click.prevent="$router.go(-1)" class="menu-back-button">

                    <v-icon>arrow_back_ios</v-icon>

                </v-btn>

                <v-btn icon @click.prevent="" v-else class="menu-back-button">

                    <v-icon small>fas fa-home</v-icon>

                </v-btn>

                <v-toolbar-title v-if="this.$route.name !== 'home'" class="text-uppercase font-size mr-3 ml-0" @click.prevent="$router.go(-1)" style="cursor: pointer;">

                    {{ $t(`route.${$route.name}`) }}

                </v-toolbar-title>

                <v-spacer></v-spacer>

                <div class="home-title-logo-container" v-if="( this.$route.name !== 'login' ) && ( this.$route.name !== 'Register' )">

                    <img class=" home-title-logo" :src="getLogo" @click.prevent.stop="$router.push({name: 'home'})" />

                </div>

                <v-spacer></v-spacer>

                <div v-if="( $store.getters.user_token == '') && ( this.$route.name !== 'login' )" class="sub-menu-flexCol top-auth-icon" @click.prevent='$router.push({name: "login"})'>

                    <i class="fas fa-sign-in-alt" style="font-size: 16px"></i>

                    <span class="menu-title" style="margin-left: 3px"> {{  $t( 'user_management.login' ) }}</span>

                </div>

                <div v-if="( $store.getters.user_token == '' ) && ( this.$route.name !== 'login' )" class="sub-menu-flexRow top-auth-icon" @click.prevent='$router.push({name: "login"})'>

                    <i class="fas fa-sign-in-alt" style="font-size: 16px"></i>

                    <span class="menu-title" style="margin-left: 3px">{{  $t( 'user_management.login' ) }}</span>

                </div>

                <div v-if="$store.getters.user_token !== '' && notification > 0" class=".sub-menu-flexCol-Notification top-auth-icon" @click.prevent='updateNotification()' style="cursor: pointer;">

                    <v-badge left overlap>

                        <template v-slot:badge>

                            <span style="font-size: 10px">{{ notification }}</span>

                        </template>

                        <i class="fas fa-bell notification-bell-size-25"></i>

                    </v-badge>

                </div>

                <v-toolbar-side-icon @click.prevent.stop="drawer = !drawer"></v-toolbar-side-icon>

            </div>

        </v-toolbar>

        <!--nav drawer-->
        <v-navigation-drawer v-model="drawer" :mini-variant="mini" fixed temporary :disable-resize-watcher="true" width="220" right class="semi-transparent-7-bg">

            <v-list class="pa-1 mt-3 transparent-bg" dense>


                <v-list-tile avatar tag="div">

                    <v-list-tile-avatar>

                        <v-icon large>assignment_ind</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-title style="font-size: 12px;">{{ getFullname }}</v-list-tile-title>

                        <v-list-tile-title class="font-size" v-if="getUsername !== 0">{{ getUsername }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider light></v-divider>

                <!-- Change Language -->
                <v-list-tile @click.prevent="sheet = true">

                    <v-list-tile-action>

                    <v-avatar size="32px" tile>

                            <img :src="getLanguageFlag">

                        </v-avatar>

                    </v-list-tile-action>

                    <v-list-tile-content style="font-size: 13px;">

                        <v-list-tile-title>{{ getLanguage }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider light class="p-0"></v-divider>

                <PWAInstallPrompt v-if="showPWAInstallPrompt" :showPWAInstallPrompt="showPWAInstallPrompt" :installEvent="installEvent" :isIosDevice="isIosDevice" @toggleDialog="togglePWAInstallGuildelineDialog" @PromptChanged="updatePWAInstallprompt"/>

                <v-divider light class="p-0"  v-if="showPWAInstallPrompt"></v-divider>

                <!--nav item-->
                <v-list-tile class="side-menu" v-for="item in sideMenu" :key="item.title" @click.prevent="triggerEvent(item)">

                    <v-list-tile-action>

                        <v-icon>{{ item.icon }}</v-icon>

                    </v-list-tile-action>

                    <v-list-tile-content style="font-size: 13px;">

                        <v-list-tile-title>{{ $t( `home.${item.title}` ) }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

            </v-list>

            <!--Bottom Sheet-->
            <v-bottom-sheet v-model="sheet" inset>

                <v-list style="background-color: #000000cc">

                    <v-subheader> {{ $t( 'home.change_language' ) }}</v-subheader>

                    <v-list-tile v-for="tile in tiles" :key="tile.title" @click.prevent="selectLanguage(tile)">

                        <v-list-tile-avatar>

                            <v-avatar size="32px" tile>

                                <img :src="getImgUrl(tile.img)" :alt="tile.title">

                            </v-avatar>

                        </v-list-tile-avatar>

                        <v-list-tile-title>{{ $t( `reusable.${tile.title}` ) }}</v-list-tile-title>

                    </v-list-tile>

                </v-list>

            </v-bottom-sheet>

            <!-- Footer
            <Footer :options="mini" /> -->

        </v-navigation-drawer>

        <IOSPWAInstallGuidelineDialog :dialog="dialog" @DialogChanged="dialog = $event.value"/>

    </div>

</template>

<style scoped>

    .toolbar-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    /* https://stackoverflow.com/questions/4767971/how-do-i-center-float-elements */
    .home-title-logo-container {
        position: absolute;
        left: 50%;
    }

    .home-title-logo {
        position: relative;
        left: -50%;
        height: 45px;
        cursor: pointer;
    }

    .top-auth-icon {
        margin-left: 5px;
        margin-right: 5px;
    }

    .v-toolbar__title.headline {
        margin-left: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .v-toolbar__side-icon {
        margin-right: 0px;
    }

    .notification-bell-size-25 {
        font-size: 25px;
    }

    @media only screen and (max-width: 959px) {
        .v-toolbar__content, .v-toolbar__extension {
            padding: 0 8px !important;
        }
    }

    @media only screen and (min-width: 599px) {
        .sub-menu-flexCol{
            display:none !important;
        }
    }

    @media only screen and (max-width: 599px) {
        .notification-bell-size-25{
            font-size: 20px;
        }
    }

    @media only screen and (max-width: 600px) {
    .sub-menu-flexRow{
            display:none !important;
        }
    }

    .sub-menu-flexRow, .sub-menu-flexCol, .sub-menu-flexCol-Notification {
        display: flex;
        text-align: center;
        cursor: pointer;
        justify-content: center;
        z-index:1;
    }

    .sub-menu-flexCol {
        flex-direction: column;
    }

    .sub-menu-flexRow {
        flex-direction: row;
        align-items: center;
    }

    .sub-menu-flexCol .menu-title {
        display: flex;
        font-size: 6px;
    }

    .menu-back-button {
        /* margin-left: 0px !important; */
        margin-right: 0px !important;
        width: 18px;
    }

    .font-size {
        font-size: 11px;
    }

</style>

<script>

import Footer from "@/components/Layout/Footer";
import Loginbar from "@/components/HomePage/Loginbar.vue";
import Api from "@/api";
import PWAInstallPrompt from '@/components/Layout/PWAInstallPrompt.vue';
import IOSPWAInstallGuidelineDialog from "@/components/Layout/IOSPWAInstallGuidelineDialog.vue";

export default {
    name: "User_header",
    components: {
        Footer,
        Loginbar,
        PWAInstallPrompt,
        IOSPWAInstallGuidelineDialog
    },
    props: {
        title: {
            type: String,
            default: "Home"
        }
    },
    mounted() {

        this.getNotification();

    },
    data() {
        return {
            sheet: false,
            drawer: null,
            notification: null,
            items: [
                {
                    title: 'home',
                    url: "home",
                    icon: "fas fa-home"
                },
                {
                    title: 'games',
                    url: "Game",
                    icon: "fas fa-gamepad"
                },
                {
                    title: 'miniGame',
                    url: "Mini Game",
                    icon: "fas fa-dice"
                },
                {
                    title: 'miniGamePrizes',
                    url: "Mini Game Prizes",
                    icon: "fa fa-trophy"
                },
                {
                    title: 'promotion',
                    url: "Promotion",
                    icon: "meeting_room"
                },
                {
                    title: 'contact' ,
                    url: "Contact",
                    icon: "fas fa-comments"
                },
                {
                    title: 'history',
                    url: "History / Deposit",
                    icon: "fas fa-history"
                },
                {
                    title: 'download',
                    url: "Download Link",
                    icon: "fas fa-download"
                },
                {
                    title: 'change_password',
                    url: "Change Password",
                    icon: "lock"
                },
                {
                    title: 'log_out',
                    url: "login",
                    icon: "meeting_room"
                }
            ],
            mini: false,
            right: null,
            tiles: [{
                    img: "CN",
                    key: 'zh-CN',
                    title: "lang_chinese"
                },
                {
                    img: "MY",
                    key: 'ms',
                    title: "lang_malay"
                },
                {
                    img: "UK",
                    key: 'en',
                    title: "lang_english"
                },
                {
                    img: "TH",
                    key: 'th',
                    title: "lang_thai"
                },
            ],
            isLogin: this.getLogin_flag,
            showPWAInstallPrompt: false,
            installEvent: null,
            isIosDevice: false,
            dialog: false
        }
    },
    created() {

        const isIos = () => {

            const userAgent = window.navigator.userAgent.toLowerCase();

            return /iphone|ipad|ipod/.test( userAgent );

        }

        // Detects if device is in standalone mode
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

          // Checks if should display install popup notification:
        if ( isIos() && !isInStandaloneMode() ) {

            this.showPWAInstallPrompt = true;

            this.isIosDevice = true;

        } else {

            window.addEventListener('beforeinstallprompt', e => {

                e.preventDefault();

                this.installEvent = e;

                this.showPWAInstallPrompt = true;

            });

        }

    },
    methods: {
        triggerEvent: function (item) {

            if (item.title ==  'log_out') {

                this.$store.dispatch('logout');

                this.$router.push({
                    name: item.url
                });

            } else {

                this.$router.push({
                    name: item.url
                });

            }

        },
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        async getNotification(){

            if(this.$store.getters.user_token !== ''){

                let res = await Api.getNotification({
                        access_token: this.$store.getters.user_token
                });

                if (res && 'success' in res && res.success === true) {

                    this.notification = res.data;

                } else {

                    if(res.message == "token invalid") {

                        this.$store.dispatch('logout', res.data);

                        this.$router.push({name: 'login'})

                    }

                }

            }

            setTimeout(() => {

                this.getNotification();

            }, 20000)
        },
        async updateNotification(){

            let res = await Api.updateNotification({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                this.notification = res.data;

            } else {

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

            this.$router.push({name: "History / Deposit"})

        },
        selectLanguage(lang){

            this.$store.dispatch('setLanguage', lang.key);

            this.$root.$i18n.locale = this.$store.getters.lang_flag;

            this.sheet = false;

        },
        updatePWAInstallprompt(params){

            this.showPWAInstallPrompt = params.showPWAInstallPrompt;

            this.installEvent = params.event;

        },

        togglePWAInstallGuildelineDialog(params) {

            this.dialog = params;

        }

    },
    computed: {
        getUsername: function() {
            return this.$store.getters.user_username === '' ? 0 : this.$store.getters.user_username;
        },
        getFullname: function() {
            return this.$store.getters.user_fullname === '' ? this.$t( 'shared.guest' ) : this.$store.getters.user_fullname;
        },
        getLogo: function() {
            return this.$store.getters.system_logo === '' ? '//assets.office4u.xyz/common_asset/webot_logo.png' : this.$store.getters.system_logo;
        },
        getLogin_flag: function() {
            return this.$store.getters.login_flag;
        },
        sideMenu: function() {

            let current = this;

            if ( this.$store.getters.services && this.$store.getters.services['mini_game_service'] == 0 ) {

                let items = this.items.filter(function(menu) {

                    if(menu.title == 'miniGame' || menu.title == 'miniGamePrizes') {

                        return false;

                    } else {

                        return true;

                    }

                });

                this.items = items;

            }

            if( this.$store.getters.user_token == '' ) {

                let items = this.items.filter(function(menu) {

                    if(menu.title == 'history' || menu.title == 'log_out' || menu.title == 'change_password' || menu.title == 'miniGame' || menu.title == 'miniGamePrizes') {

                        return false;

                    } else {

                        return true;

                    }

                });

                return items;

            }

            return this.items;

        },
        getLanguage: function() {

            if ( this.$store.getters.lang_flag == 'en') {

                return 'English';

            } else if ( this.$store.getters.lang_flag == 'zh-CN' ) {

                return '华文';

            } else if ( this.$store.getters.lang_flag == 'ms') {

                return 'Melayu';

            }else if ( this.$store.getters.lang_flag == 'th') {

                return 'ไทย';

            }

            return 'English';
        },
        getLanguageFlag: function() {

            if ( this.$store.getters.lang_flag == 'en') {

                return this.getImgUrl('UK');

            } else if ( this.$store.getters.lang_flag == 'zh-CN' ) {

               return this.getImgUrl('CN');

            } else if ( this.$store.getters.lang_flag == 'ms') {

                return this.getImgUrl('MY');

            }else if ( this.$store.getters.lang_flag == 'th') {

                return this.getImgUrl('TH');

            }

            return this.getImgUrl('UK');
        },
    }
}
</script>
